// removed by extract-text-webpack-plugin
module.exports = {"navbar":"style__navbar___3Q04_"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/navbar/style.scss
 ** module id = 365
 ** module chunks = 0
 **/